var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0068 80C19.1289 80 23.2812 75.325 23.2812 69.558C23.2812 63.7911 19.1289 59.116 14.0068 59.116C8.88471 59.116 4.73242 63.7911 4.73242 69.558C4.73242 75.325 8.88471 80 14.0068 80Z",
    fill: "#008BCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9453 80C46.0674 80 50.2197 75.325 50.2197 69.558C50.2197 63.7911 46.0674 59.116 40.9453 59.116C35.8232 59.116 31.6709 63.7911 31.6709 69.558C31.6709 75.325 35.8232 80 40.9453 80Z",
    fill: "#008BCD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4346 80C72.5567 80 76.709 75.325 76.709 69.558C76.709 63.7911 72.5567 59.116 67.4346 59.116C62.3124 59.116 58.1602 63.7911 58.1602 69.558C58.1602 75.325 62.3124 80 67.4346 80Z",
    fill: "#008BCD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5385 47.4684H62.5781V51.9748H64.5385V47.4684Z",
    fill: "#008BCD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 0C2.98858 0 0.75 2.23858 0.75 5V46.9719C0.75 49.7333 2.98858 51.9719 5.75 51.9719H56.998V47.4656V45.9902V43.9954H56.506L55.7744 27.9535H42.3752V23.6309H55.5781H57.5564H60.7838L63.7537 27.5115L66.6293 23.6309L72.9389 24.5637L73.3468 40.7204H70.67L70.5247 43.9954H70.1168V45.9902V47.4656V51.9719H75.75C78.5114 51.9719 80.75 49.7333 80.75 46.9719V4.99999C80.75 2.23857 78.5114 0 75.75 0H5.75ZM63.6186 22.3106C59.3154 22.3106 55.8228 18.3812 55.8228 13.5362C55.8228 8.69116 59.3128 4.76177 63.6186 4.76177C67.9244 4.76177 71.4119 8.69116 71.4119 13.5362C71.4119 18.3812 67.9193 22.3106 63.6186 22.3106Z",
    fill: "#008BCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.1c04886dc82a83109bc126b9f7a76f0e.svg";
export { ForwardRef as ReactComponent };